export default "__VITE_ASSET__dc77e410__"